import { render, staticRenderFns } from "./NewsCenter_Component.vue?vue&type=template&id=c1ac8718&scoped=true&"
import script from "./NewsCenter_Component.vue?vue&type=script&lang=js&"
export * from "./NewsCenter_Component.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenter_Component.vue?vue&type=style&index=0&id=c1ac8718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ac8718",
  null
  
)

export default component.exports